export const API = {
    //   baseURL:'http://192.168.2.68/economic/',//ZQ登录用
    //   baseDataURL:'http://192.168.2.68/economic/auth/server/',//数据接口
    //   baseReviewURL:'http://192.168.2.68/economic/review/server/',
    //   UploadsService:'http://192.168.2.68/economic/fileInfo/server/',//上传下载地址

    // baseURL:'http://192.168.2.21:8763/',//ZQ登录用
    // baseDataURL:'http://192.168.2.21:8763/auth/server/',//数据接口
    // baseReviewURL:'http://192.168.2.21:8763/review/server/',
    // UploadsService:'http://192.168.2.21:8763/fileInfo/server/',//上传下载地址

    // baseURL:'http://192.168.2.92/economic/',//ZQ登录用
    // baseDataURL:'http://192.168.2.92/economic/auth/server/',//数据接口
    // baseReviewURL:'http://192.168.2.92/economic/review/server/',
    // UploadsService:'http://192.168.2.92/economic/fileInfo/server/',//上传下载地址

    //  baseURL:'http://192.168.2.21:8763/',//朱庆登录地址; 用于登录接口
    //  baseDataURL:'http://192.168.2.21:8763/auth/server/',//朱庆的接口
    //  baseReviewURL:'http://192.168.2.21:8763/review/server/',//陈科武的接口
    //  UploadsService:'http://192.168.2.21:8763/fileInfo/server/',//上传下载地址

    // baseURL:'http://192.168.95.16:8763/',//朱庆登录地址; 用于登录接口
    // baseDataURL:'http://192.168.95.16:8763/auth/server/',//朱庆的接口
    // baseReviewURL:'http://192.168.95.16:8763/review/server/',//陈科武的接口
    // UploadsService:'http://192.168.95.16:8763/fileInfo/server/',//上传下载地址
    // ## 原本
    //  baseURL:'http://www.loongine.com/economic/',//朱庆登录地址; 用于登录接口
    //  baseDataURL:'http://www.loongine.com/economic/auth/server/',//朱庆的接口
    //  baseReviewURL:'http://www.loongine.com/economic/review/server/',//陈科武的接口
    //  UploadsService:'http://www.loongine.com/economic/fileInfo/server/',//上传下载地址


    //  baseURL:'http://117.175.169.87:8763/',//朱庆登录地址; 用于登录接口
    // baseDataURL:'http://117.175.169.87:8763/auth/server/',//朱庆的接口
    // baseReviewURL:'http://117.175.169.87:8763/review/server/',//陈科武的接口
    // UploadsService:'http://117.175.169.87:8763/fileInfo/server/',//上传下载地址

    // 测试
    // baseURL: 'http://192.168.0.160:8763/', // 用于登录接口
    // baseDataURL: 'http://192.168.0.160:8763/auth/server/',
    // baseReviewURL: 'http://192.168.0.160:8763/review/server/',
    // UploadsService: 'http://192.168.0.160:8763/fileInfo/server/' // 上传下载地址
    //网关

    // // 测试
    // baseURL: 'http://192.168.100.172:8763/', // 用于登录接口
    // baseDataURL: 'http://192.168.100.172:8763/auth/server',
    // baseReviewURL: 'http://192.168.100.172:8763/review/server/',
    // UploadsService: 'http://192.168.100.172:11084/fileInfo/server/' // 上传下载地址

    // 线上2地址
    // baseURL: 'https://crweb.loongine.com/economic/', // 用于登录接口
    // baseDataURL: 'https://crweb.loongine.com/economic/auth/server',
    // baseReviewURL: 'https://crweb.loongine.com/economic/review/server/',
    // UploadsService: 'https://crweb.loongine.com/economic/fileInfo/server/' // 上传下载地址
    // 线上1 地址
    //  baseURL:'//www.loongine.com/economic/',//朱庆登录地址; 用于登录接口
    //  baseDataURL:'//www.loongine.com/economic/auth/server/',//朱庆的接口
    //  baseReviewURL:'//www.loongine.com/economic/review/server/',//陈科武的接口
    //  UploadsService:'//www.loongine.com/economic/fileInfo/server/',//上传下载地址

    // 本地彭庆
    //  baseURL:'http://192.168.0.160:8763',//彭庆登录地址; 用于登录接口
    //  baseDataURL:'http://192.168.0.160:8764/auth/server/',//彭庆的接口
    //  baseReviewURL:'http://192.168.0.160:8762/review/server/',//彭庆的接口
    //  UploadsService:'http://192.168.0.160:8765/economic/fileInfo/server/',//上传下载地址

    // 本地小吕
     baseURL:'http://139.198.6.19:9905',//彭庆登录地址; 用于登录接口
     baseDataURL:'http://139.198.6.19:9905/auth/server/',//彭庆的接口
     baseReviewURL:'http://139.198.6.19:9905/review/server/',//彭庆的接口
     UploadsService:'http://139.198.6.19:9905/economic/fileInfo/server/',//上传下载地址

}